import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'hidePhoneNumber'
})
export class HidePhoneNumberPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }

    const ukPrefix = '+44';
    const irelandPrefix = '+353';

    if (value.startsWith(ukPrefix)) {
      const digitsLength = value.length - ukPrefix.length;
      return `${ukPrefix} ${'*'.repeat(digitsLength)}`;
    }

    if (value.startsWith(irelandPrefix)) {
      const digitsLength = value.length - irelandPrefix.length;
      return `${irelandPrefix} ${'*'.repeat(digitsLength)}`;
    }

    return value;
  }
}
